import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetAllCommunities() {
    const res = await fetch(`${API_URL}/communities`, {headers: authHeaders()});
    return res.json();
}

export async function apiGetCommunities(groupId) {
    const res = await fetch(`${API_URL}/groups/${groupId}/communities`, {headers: authHeaders()});
    return res.json();
}

export async function apiCreateCommunity(groupId, title, description, created_by, groupIds) {
    const res = await fetch(`${API_URL}/groups/${groupId}/communities`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({title, description, created_by, group_ids: groupIds || []})
    });
    return res.json();
}

export async function apiDeleteCommunity(communityId) {
    const res = await fetch(`${API_URL}/communities/${communityId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}

export async function apiGetCommunityPosts(communityId) {
    const res = await fetch(`${API_URL}/communities/${communityId}/posts`, {headers: authHeaders()});
    return res.json();
}

export async function apiCreateCommunityPost(communityId, content, isAnonymous, realName) {
    const res = await fetch(`${API_URL}/communities/${communityId}/posts`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({content, is_anonymous: isAnonymous, real_name: realName})
    });
    return res.json();
}

export async function apiDeleteCommunityPost(postId) {
    const res = await fetch(`${API_URL}/community-posts/${postId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}

export async function apiLikeCommunityPost(postId) {
    const res = await fetch(`${API_URL}/community-posts/${postId}/like`, {
        method: "POST",
        headers: authHeaders()
    });
    return res.json();
}
